import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../components/Navbar";
import Styles from "../../styles/session/assignformat.module.scss";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { adminRoutes } from "../../routers/AdminRouters";
import {
  getSessionById,
  getSessionFormatCategory,
  addSessionFormatCategory,
  deleteSessionFormatCategory,
  updateSessionFormatCategory,
} from "../../services";
import ReactQuill from "react-quill";
import { useSelector } from "react-redux";
import {
  dispatch,
  saveSessionDetails,
  saveSubmittedData,
  toggle,
} from "../../redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function hhmmssToSeconds(time) {
  const [hours, minutes, seconds] = time.split(":").map(Number);
  return hours * 3600 + minutes * 60 + seconds;
}
function secondsToHhmmss(totalSeconds) {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return [hours, minutes, seconds]
    .map((unit) => String(unit).padStart(2, "0"))
    .join(":");
}
const AssignFormatFirst = () => {
  const { sessionId } = useParams();
  const { formatCategories, sessionDetails, formats } = useSelector(
    (state) => state.sessionFormats,
  );

  const navigate = useNavigate();
  const [restPeriods, setRestPeriods] = useState("");
  const [format, setSelectedFormat] = useState("");
  const [subFormat, setSelectedSubFormat] = useState("");
  const [restPeriodDetails, setRestPeriodDetails] = useState("");
  const [sesssionDetails, setSessionDetails] = useState();
  const isSidebarOpen = useSelector((state) => state.navbar.button);
  const hoursRef = useRef(null);
  const minutesRef = useRef(null);
  const secondsRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [showSubModal, setShowSubModal] = useState(false);
  const [newFormat, setNewFormat] = useState("");
  const [newSubFormat, setNewSubFormat] = useState("");
  const [formatError, setFormatError] = useState("");
  const location = useLocation();

  const handleMainContainerClick = () => {
    if (isSidebarOpen) {
      dispatch(toggle());
    }
  };
  useEffect(() => {
    const hasRefreshed = sessionStorage.getItem("hasRefreshed");
    const AssignFormatSecond = sessionStorage.getItem("AssignFormatSecond");

    if (!hasRefreshed && !AssignFormatSecond && sessionId) {
      sessionStorage.setItem("hasRefreshed", "true");
      window.location.reload();
    }

    return () => {
      sessionStorage.removeItem("AssignFormatSecond");
    };
  }, [sessionId]);

  useEffect(() => {
    const fetchData = async () => {
      getSessionFormatCategory();
    };
    fetchData();
  }, []);
  useEffect(() => {
    if (!sessionDetails) {
      navigate(adminRoutes.listSession);
    }
  }, [sessionDetails, navigate]);

  useEffect(() => {
    const fetchSession = async () => {
      try {
        const response = await getSessionById(sessionId);

        if (response) {
          const details = {
            sessionId: response._id,
            name: response.name,
            code: response.code,
            details: response.details,
            thankyou: response.thankyou,
          };

          setSessionDetails(details);
          dispatch(saveSessionDetails(details));
        }
      } catch (error) {
        console.error("Error fetching session details:", error);
      }
    };

    if (sessionId) {
      fetchSession();
    }
  }, [sessionId]);
  const handleFormatChange = (event) => {
    const selectedFormat = event.target.value;
    if (selectedFormat === "add-new") {
      setShowModal(true);
      setSelectedFormat("");
    } else {
      setFormatError("");
      setSelectedFormat(selectedFormat);
      setSelectedSubFormat("");
    }
  };

  const handleSubFormatClick = () => {
    if (!format) {
      setFormatError("Please select a format first");
    } else {
      setFormatError("");
    }
  };

  const handleAddFormatToBackend = async () => {
    if (!newFormat.trim()) {
      toast.error("Please enter a format name");
      return;
    }
    const response = await addSessionFormatCategory({ name: newFormat });
    if (response) {
      getSessionFormatCategory();
      setNewFormat("");
    }
  };

  const handleDeleteFormat = async (id) => {
    const response = await deleteSessionFormatCategory(id);
    if (response) {
      getSessionFormatCategory();
    }
  };

  const handleSubFormatChange = (event) => {
    if (!format) {
      setFormatError("Please select a format first");
      return;
    }
    const selectedSub = event.target.value;
    if (selectedSub === "add-new") {
      if (!format) {
        toast.error("Please select a Format first", { position: "top-right" });
        return;
      }
      setShowSubModal(true);
      setSelectedSubFormat("");
    } else {
      setSelectedSubFormat(selectedSub);
    }
  };

  const handleAddSubFormatToBackend = async () => {
    if (!newSubFormat.trim()) {
      toast.error("Please enter a sub-format name");
      return;
    }
    const currentFormatObj = formatCategories.find(
      (item) => item.name === format,
    );
    if (!currentFormatObj) return;

    const updatedSubFormats = [
      ...(currentFormatObj.subFormats || []),
      newSubFormat,
    ];
    const response = await updateSessionFormatCategory(currentFormatObj._id, {
      subFormats: updatedSubFormats,
    });
    if (response) {
      getSessionFormatCategory();
      setNewSubFormat("");
    }
  };

  const handleDeleteSubFormat = async (subFormatToDelete) => {
    const currentFormatObj = formatCategories.find(
      (item) => item.name === format,
    );
    if (!currentFormatObj) return;

    const updatedSubFormats = currentFormatObj.subFormats.filter(
      (item) => item !== subFormatToDelete,
    );
    const response = await updateSessionFormatCategory(currentFormatObj._id, {
      subFormats: updatedSubFormats,
    });
    if (response) {
      getSessionFormatCategory();
      toast.success("Sub-format deleted successfully");
    }
  };
  useEffect(() => {
    // Function to prevent typing the minus key
    const preventNegativeInput = (e) => {
      if (e.key === "-") {
        e.preventDefault();
      }
    };

    // Get references to the input elements
    const inputs = [hoursRef.current, minutesRef.current, secondsRef.current];

    // Add event listeners to all input elements
    inputs.forEach((input) => {
      if (input) {
        input.addEventListener("keydown", preventNegativeInput);
      }
    });

    // Clean up event listeners when component unmounts
    return () => {
      inputs.forEach((input) => {
        if (input) {
          input.removeEventListener("keydown", preventNegativeInput);
        }
      });
    };
  }, []);
  const handleTimeChange = (e, field) => {
    let value = e.target.value.replace(/\D/g, ""); // Only digits

    if (value.length > 2) {
      value = value.slice(-2);
    }

    if (field === "hours") {
      if (parseInt(value, 10) > 24) {
        value = "24";
      }
    }

    if (field === "minutes" || field === "seconds") {
      if (parseInt(value, 10) > 59) {
        value = "59";
      }
    }

    if (field === "hours") hoursRef.current.value = value;
    if (field === "minutes") minutesRef.current.value = value;
    if (field === "seconds") secondsRef.current.value = value;

    const h = parseInt(hoursRef.current.value || "0", 10);
    const m = parseInt(minutesRef.current.value || "0", 10);
    const s = parseInt(secondsRef.current.value || "0", 10);

    setRestPeriods(h * 3600 + m * 60 + s);
  };

  const padTimeValue = (ref) => {
    if (ref.current && ref.current.value) {
      ref.current.value = ref.current.value.padStart(2, "0");
    } else if (ref.current) {
      ref.current.value = "00";
    }
  };

  const handleSubmit = async () => {
    if (!format || !subFormat || !restPeriods) {
      toast.error("Please fill all the fields", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return;
    }

    const formData = {
      sessionId,
      formatId: formatCategories.find(
        (formatItem) => formatItem.name === format,
      )?._id,
      format,
      subFormat,
      restPeriods,
      sessionDetails,
      restPeriodDetails,
    };

    console.log("Dispatching formData to Redux:", formData); // Debugging log
    dispatch(saveSubmittedData(formData));
    navigate(adminRoutes.assignFormatSecond.replace(":sessionId", sessionId));
  };
  useEffect(() => {
    if (formats) {
      console.log("Formats Object:", formats); // Debugging Log

      setSelectedFormat(formats.format || "");
      setSelectedSubFormat(formats.subFormat || "");
      setRestPeriods(formats.restPeriods || 0); // Keep restPeriods as number
      setRestPeriodDetails(formats.restPeriodDetails || "");
      setSessionDetails(formats.sessionDetails || {});

      // Convert to HH:MM:SS and update input fields
      const totalSeconds = formats.restPeriods || 0;
      hoursRef.current.value = String(Math.floor(totalSeconds / 3600)).padStart(
        2,
        "0",
      );
      minutesRef.current.value = String(
        Math.floor((totalSeconds % 3600) / 60),
      ).padStart(2, "0");
      secondsRef.current.value = String(totalSeconds % 60).padStart(2, "0");
    }
  }, [formats]);

  const handleBack = async () => {
    navigate(adminRoutes.listFormat.replace(":sessionId", sessionId));
    window.location.reload();
  };

  return (
    <>
      <ToastContainer />

      <Navbar />
      <div
        className={Styles.assign_list_container}
        onClick={handleMainContainerClick}
      >
        {" "}
        <h2>
          <Link to={adminRoutes.listSession}>HOME / </Link>{" "}
          <span> CREATE NEW FORMAT</span>
        </h2>
        <div className={Styles.table_container_main}>
          <div className={Styles.table_container}>
            <div className={Styles.table_container_heading}>
              <div className={Styles.table_container_headingone}>
                <h3>CREATE NEW FORMAT</h3>
              </div>
              <div className={Styles.table_container_headingtwo}>
                <div className={Styles.create_new_assign}>
                  <h6>Session Name</h6>
                  <p>{sessionDetails.name}</p>
                </div>
              </div>
            </div>
            <div className={Styles.seperator}>
              <hr className={Styles.line} />
            </div>
          </div>
          <div className={Styles.progress_indicator}>
            <div className={Styles.progress_line}>
              <div className={`${Styles.step} ${Styles.active}`}>
                <div className={Styles.circle}></div>
              </div>
              <div className={`${Styles.line} ${Styles.active}`}></div>

              <div className={`${Styles.step} ${Styles.inactive}`}>
                <div className={Styles.circle}></div>
              </div>
              <div className={`${Styles.line} ${Styles.inactive}`}></div>

              <div className={`${Styles.step} ${Styles.inactive}`}>
                <div className={Styles.circle}></div>
              </div>
            </div>
            <div className={Styles.label}>Enter Details</div>
          </div>

          <div className={Styles.assign_format_container}>
            <div className={Styles.createsession_form}>
              <div className={Styles.createsession_form_containerone}>
                <div>
                  <label className={Styles.label}>Format</label>
                  <select
                    onChange={handleFormatChange}
                    value={format}
                    className={Styles.dropdown_select}
                  >
                    <option value="" disabled selected>
                      Choose a format
                    </option>
                    {formatCategories.map((formatItem) => (
                      <option key={formatItem._id} value={formatItem.name}>
                        {formatItem.name}
                      </option>
                    ))}
                    <option
                      value="add-new"
                      style={{ color: "#f79328", fontWeight: "bold" }}
                    >
                      + Add New
                    </option>
                  </select>
                </div>
              </div>

              <div className={Styles.createsession_form_containertwo}>
                <div>
                  {formatError && (
                    <p
                      style={{
                        color: "#ff0000",
                        fontSize: "0.8rem",
                        marginBottom: "5px",
                        fontFamily: "gotham_bookregular",
                      }}
                    >
                      {formatError}
                    </p>
                  )}
                  <label className={Styles.label}>Sub-Format</label>
                  <select
                    onChange={handleSubFormatChange}
                    onMouseDown={handleSubFormatClick}
                    value={subFormat}
                    className={Styles.dropdown_select}
                  >
                    <option value="" disabled selected>
                      Choose a sub-format
                    </option>
                    {formatCategories
                      .find((formatItem) => formatItem.name === format)
                      ?.subFormats.map((subFormat, index) => (
                        <option key={index} value={subFormat}>
                          {subFormat}
                        </option>
                      ))}
                    <option
                      value="add-new"
                      style={{ color: "#f79328", fontWeight: "bold" }}
                    >
                      + Add New
                    </option>
                  </select>
                </div>
              </div>

              <div className={Styles.createsession_form_containertwo}>
                <label className={Styles.label}>Rest Time</label>
                <div className={Styles.time_field}>
                  <span className={Styles.icon}>
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.333 22C17.8559 22 22.333 17.5228 22.333 12C22.333 6.47715 17.8559 2 12.333 2C6.81016 2 2.33301 6.47715 2.33301 12C2.33301 17.5228 6.81016 22 12.333 22Z"
                        stroke="#808080"
                        stroke-width="1.5"
                      />
                      <path
                        d="M12.333 8V12L14.333 14"
                        stroke="#808080"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                  <input
                    type="text"
                    placeholder="00"
                    className={Styles.time_input}
                    ref={hoursRef}
                    defaultValue={String(
                      Math.floor(restPeriods / 3600),
                    ).padStart(2, "0")}
                    onChange={(e) => handleTimeChange(e, "hours")}
                    onBlur={() => padTimeValue(hoursRef)}
                  />
                  <span className={Styles.separator}>:</span>
                  <input
                    type="text"
                    placeholder="00"
                    className={Styles.time_input}
                    ref={minutesRef}
                    defaultValue={String(
                      Math.floor((restPeriods % 3600) / 60),
                    ).padStart(2, "0")}
                    onChange={(e) => handleTimeChange(e, "minutes")}
                    onBlur={() => padTimeValue(minutesRef)}
                  />
                  <span className={Styles.separator}>:</span>
                  <input
                    type="text"
                    placeholder="00"
                    className={Styles.time_input}
                    ref={secondsRef}
                    defaultValue={String(restPeriods % 60).padStart(2, "0")}
                    onChange={(e) => handleTimeChange(e, "seconds")}
                    onBlur={() => padTimeValue(secondsRef)}
                  />
                </div>
              </div>
            </div>
            <div className={Styles.createsession_form_containerright}>
              <label className={Styles.label}>
                Enter Resting Period Details
              </label>
              <div className="second-quill">
                <ReactQuill
                  theme="snow"
                  placeholder="Enter here..."
                  className={Styles.customQuill}
                  value={restPeriodDetails} // Set initial value
                  onChange={(val) => setRestPeriodDetails(val)}
                />
              </div>
            </div>
          </div>
          <div className={Styles.seperator}>
            <hr className={Styles.line} />
          </div>
          <div className={Styles.button_group}>
            <button
              className={Styles.save_button}
              onClick={handleSubmit}
              style={{ cursor: "pointer" }}
            >
              Next
            </button>
            <button
              className={Styles.cancel_button}
              onClick={handleBack}
              style={{ cursor: "pointer" }}
            >
              Cancel
            </button>
          </div>
        </div>
        {/* Update List Modal/Side Panel */}
        {showModal && (
          <div className={Styles.update_list_modal_overlay}>
            <div className={Styles.update_list_modal}>
              <div className={Styles.modal_header}>
                <h3>UPDATE LIST</h3>
              </div>
              <div className={Styles.modal_content}>
                <div className={Styles.list_items_container}>
                  {formatCategories.map((item) => (
                    <div key={item._id} className={Styles.list_item}>
                      <span>{item.name}</span>
                      <button
                        onClick={() => handleDeleteFormat(item._id)}
                        className={Styles.delete_btn}
                      >
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13 1L1 13"
                            stroke="white"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M1 1L13 13"
                            stroke="white"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                  ))}
                </div>

                <div className={Styles.modal_separator}></div>

                <div className={Styles.add_new_section}>
                  <label>Add new to list</label>
                  <div className={Styles.input_group}>
                    <input
                      type="text"
                      placeholder="Enter here"
                      value={newFormat}
                      onChange={(e) => setNewFormat(e.target.value)}
                    />
                    <button
                      onClick={handleAddFormatToBackend}
                      className={Styles.plus_btn}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8 1V15"
                          stroke="#F79328"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                        <path
                          d="M1 8H15"
                          stroke="#F79328"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>

                <div className={Styles.modal_footer}>
                  <button
                    onClick={() => setShowModal(false)}
                    className={Styles.save_btn}
                  >
                    Save
                  </button>
                  <button
                    onClick={() => setShowModal(false)}
                    className={Styles.cancel_btn_modal}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* Update Sub-Format List Modal */}
        {showSubModal && (
          <div className={Styles.update_list_modal_overlay}>
            <div className={Styles.update_list_modal}>
              <div className={Styles.modal_header}>
                <h3>UPDATE SUB-FORMAT LIST</h3>
                <p
                  style={{
                    color: "#aaa",
                    fontSize: "0.8rem",
                    marginTop: "5px",
                  }}
                >
                  Format: {format}
                </p>
              </div>
              <div className={Styles.modal_content}>
                <div className={Styles.list_items_container}>
                  {formatCategories
                    .find((item) => item.name === format)
                    ?.subFormats.map((sub, index) => (
                      <div key={index} className={Styles.list_item}>
                        <span>{sub}</span>
                        <button
                          onClick={() => handleDeleteSubFormat(sub)}
                          className={Styles.delete_btn}
                        >
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M13 1L1 13"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M1 1L13 13"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                      </div>
                    ))}
                </div>

                <div className={Styles.modal_separator}></div>

                <div className={Styles.add_new_section}>
                  <label>Add new to list</label>
                  <div className={Styles.input_group}>
                    <input
                      type="text"
                      placeholder="Enter here"
                      value={newSubFormat}
                      onChange={(e) => setNewSubFormat(e.target.value)}
                    />
                    <button
                      onClick={handleAddSubFormatToBackend}
                      className={Styles.plus_btn}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8 1V15"
                          stroke="#F79328"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                        <path
                          d="M1 8H15"
                          stroke="#F79328"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>

                <div className={Styles.modal_footer}>
                  <button
                    onClick={() => setShowSubModal(false)}
                    className={Styles.save_btn}
                  >
                    Save
                  </button>
                  <button
                    onClick={() => setShowSubModal(false)}
                    className={Styles.cancel_btn_modal}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default AssignFormatFirst;
